import { createSelector } from '@reduxjs/toolkit';
import {
  selectItemById, defaultItemSelectorByVanityUrlLowercase,
} from '../lib';
import { actSelectors } from '..';

/**
 * Get an artist by ID.
 * @param state
 * @param id
 * @return {*}
 */
export const getActById = actSelectors.selectById;

export const getActByByVanityUrl = createSelector(
  actSelectors.selectEntities,
  selectItemById,
  defaultItemSelectorByVanityUrlLowercase,
);
